import moment from 'moment';

export function formatTimestamp(iso: string): string {
  if (!iso) return '\u2014';
  const m = moment(iso);
  if (!m.isValid()) return '\u2014';
  return m.format('MMM D, YYYY h:mm A');
}

export function displayName(
  firstName?: string | null,
  lastName?: string | null,
  fallback = 'Unknown'
): string {
  const name = `${firstName ?? ''} ${lastName ?? ''}`.trim();
  return name || fallback;
}
